import { Button, Modal, Form, Input } from "rsuite";
import styles from "./PreviewEmailModal.module.css";
import { usePreviewEmailModal } from "./usePreviewEmailModal";
import React, { useRef, useState } from "react";
import axios from "axios";
import { usePurchaseOrders } from "../../../../usePurchaseOrders";
import { showToast } from "../../../../../../Components/Toast";

const Textarea = React.forwardRef((props, ref) => (
  <Input {...props} as="textarea" ref={ref} />
));
function PreviewEmailModal() {
  const {
    display,
    closeModal,
    email,
    cc_email_1,
    cc_email_2,
    subject,
    emailBody,
    purchaseOrderId,
    vendorIndex,
    vendorId,
    vendorName,
    handleEmailBody,
    handleEmail,
    handleCcEmail1,
    handleCcEmail2,
    handleSubject,
  } = usePreviewEmailModal();
  const [loading, setLoading] = useState(false);
  const { ongenerateRLPreview, generatingRL, form, inquire } =
    usePurchaseOrders();
  const requisitionNumber = form?.requisitionNumber;

  const handleInquire = async (
    vendorIndex,
    vendorId,
    vendorName,
    emailBody,
  ) => {
    setLoading(true);
    await inquire(vendorIndex, vendorId, vendorName, emailBody, {
      email,
      cc_email_1,
      cc_email_2,
      subject,
    });

    setLoading(false);
    closeModal();
  };

  const previewRLButton = (
    <>
      <Button
        loading={generatingRL}
        onClick={() => {
          ongenerateRLPreview(purchaseOrderId, requisitionNumber);
        }}
        appearance="default"
        style={{ width: 200, margin: "15px 0px 15px 20px" }}
      >
        Preview Requisition Form
      </Button>
    </>
  );

  const InquireButton = (
    <>
      <Button
        loading={loading}
        onClick={() => {
          handleInquire(vendorIndex, vendorId, vendorName, emailBody);
        }}
        color="violet"
        appearance="primary"
        style={{ width: 130 }}
      >
        Send Inquiry
      </Button>
    </>
  );

  return (
    <>
      <Modal size="md" open={display} onClose={closeModal}>
        <Modal.Header>
          <Modal.Title>
            <div className={styles.container_title}>
              Preview of Inquiry Email to {vendorName}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.container}>
            <Form>
              <div className={styles.inputs_container}>
                <div style={{ display: "flex", gap: "16px" }}>
                  <Form.Group controlId="email">
                    <Form.ControlLabel>Email</Form.ControlLabel>
                    <Form.Control
                      name="email"
                      style={{ width: "269px" }}
                      value={email}
                      onChange={handleEmail}
                    />
                  </Form.Group>
                  <Form.Group controlId="cc_email_1">
                    <Form.ControlLabel>Additional Email 1</Form.ControlLabel>
                    <Form.Control
                      name="cc_email_1"
                      style={{ width: "210px" }}
                      value={cc_email_1}
                      onChange={handleCcEmail1}
                    />
                  </Form.Group>
                  <Form.Group controlId="cc_email_2">
                    <Form.ControlLabel>Additional Email 2</Form.ControlLabel>
                    <Form.Control
                      name="cc_email_2"
                      style={{ width: "210px" }}
                      value={cc_email_2}
                      onChange={handleCcEmail2}
                    />
                  </Form.Group>
                </div>
                <Form.Group controlId="email_subject">
                  <Form.ControlLabel>Email subject</Form.ControlLabel>
                  <Form.Control
                    name="email_subject"
                    style={{ width: "720px" }}
                    value={subject}
                    onChange={handleSubject}
                  />
                </Form.Group>

                <Form.Group controlId="email_body">
                  <Form.ControlLabel>Email body</Form.ControlLabel>
                  <Form.Control
                    accepter={Textarea}
                    name="email_body"
                    style={{
                      minHeight: "250px",
                      maxHeight: "250px",
                      width: "720px",
                    }}
                    onChange={handleEmailBody}
                    value={emailBody}
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div></div>
          {previewRLButton}
          {InquireButton}
          <Button
            onClick={() => {
              closeModal();
            }}
            appearance="subtle"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PreviewEmailModal;
